import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import { css } from "styled-components";

export interface HistoryFilterProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    clearButton?: ButtonPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const historyFilterProps: HistoryFilterProps = {
    wrapper: {},
    container: formSmallGridProps.gridContainer,
    clearButton: { variant: "secondary" },
    tagWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => spacingStyles(x.theme.design.typography.spacing.base, null)}
                `,
            },
        },
    },
};

export interface HistoryTableProps {
    loadingOverlay?: LoadingOverlayProps;
    container?: InjectableCss;
    wrapper?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: DataTableProps;
    headingWrapper?: FlexWrapperPresentationProps;
    checkboxHeader?: DataTableHeaderProps;
    checkboxCell?: DataTableCellProps;
    orderNumberHeader?: DataTableHeaderProps;
    orderNumberCell?: DataTableCellProps;
    dateHeader?: DataTableHeaderProps;
    dateCell?: DataTableCellProps;
    shipToHeader?: DataTableHeaderProps;
    shipToCell?: DataTableCellProps;
    customerPOHeader?: DataTableHeaderProps;
    customerPOCell?: DataTableCellProps;
    statusHeader?: DataTableHeaderProps;
    statusCell?: DataTableCellProps;
    totalHeader?: DataTableHeaderProps;
    totalCell?: DataTableCellProps;
    buttonHeader?: DataTableHeaderProps;
    buttonCell?: DataTableCellProps;
    button?: ButtonPresentationProps;
}

export const historyTableProps: HistoryTableProps = {
    loadingOverlay: { minHeight: 150 },
    container: {
        css: css`
            ${x => spacingStyles(x.theme.design.typography.spacing.large, null)}
        `,
    },
    wrapper: tableProps.wrapper,
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
    dataTable: tableProps.dataTable,
    headingWrapper: {
        gap: pxToRem(16),
        verticalGap: pxToRem(8),
        extendedStyles: {
            wrapper: resultCountProps.wrapper,
            content: {
                css: css`
                    justify-content: space-between;
                `,
            },
        },
    },
    checkboxHeader: tableProps.selectionCell,
    checkboxCell: tableProps.selectionCell,
    orderNumberHeader: {},
    orderNumberCell: {},
    dateHeader: {},
    dateCell: {},
    shipToHeader: tableProps.tightHeader,
    shipToCell: tableGetEllipsisCellProps(290),
    customerPOHeader: {},
    customerPOCell: tableGetEllipsisCellProps(95),
    statusHeader: {},
    statusCell: tableGetEllipsisCellProps(95),
    totalHeader: tableProps.amountHeader,
    totalCell: tableProps.amountCell,
    buttonHeader: tableProps.tightHeader,
    buttonCell: tableProps.tightCell,
    button: tableProps.button,
};
